module.exports = __webpack_public_path__ + "img/hr-uranium-ore-glow.e4ea79e6.png";